module.exports = __webpack_public_path__ + "img/s_01.95dc4074.png";